$(document).ready(function(){
  $('.reviews__list').slick({
    arrows: false,
    dots: true,
    speed: 2500,
    easing: 'ease',
    autoplay: true,
    autoplayspeed: 6000,
  });
});
